import PearlLogoLoader from 'components/PearlLogoLoader';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import StepForm from '../../stepForm';
import stepsConfig from '../../stepsConfig';

/**
 * Shared wrapper for StepForm-based wizard steps.
 * Each step page passes its config key and only the props it needs.
 */
function WizardStepPage({
    stepKey,
    isStepDataLoading = false,
    tripId,
    ensureTripId,
    initialImageUrl,
    pendingImagePreviewUrl,
    onPendingImageSelect,
    onPendingImageClear,
    basePrice,
    formData,
    onChange,
    errors,
    setErrors,
    hssTemplates,
    paymentTemplates,
    onToggleTemplate,
    onNewTemplate,
    onEditTemplate,
    duration,
    itineraryDays,
    onDayChange,
    onAddLineItem,
    onLineItemChange,
    onRemoveLineItem,
    tripComponents,
    itineraryDaysList,
    cityOptions,
    isCitiesLoading,
    tripCountry,
    takenCountries = [],
    onNewComponent,
    onNewHssTemplate,
    onSearchExistingComponent,
    tripCurrency,
    lookupOptions,
    itemDefaults,
    tripsList,
    isTripsLoading,
    packageId,
    packageInitialImageUrl,
    pendingPackageImagePreviewUrl,
    onPendingPackageImageSelect,
    onPendingPackageImageClear,
}) {
    const stepConfig = stepsConfig[stepKey];
    if (!stepConfig) {
        return (
            <MDTypography variant="body2" color="error">
                Unknown wizard step: {String(stepKey)}
            </MDTypography>
        );
    }

    return (
        <>
            {isStepDataLoading && (
                <MDBox mb={2} display="flex" alignItems="center" gap={1}>
                    <PearlLogoLoader size="xs" showMessage={false} message="" />
                    <MDTypography variant="caption" color="text">
                        Fetching latest data...
                    </MDTypography>
                </MDBox>
            )}
            <StepForm
                tripId={tripId}
                ensureTripId={ensureTripId}
                initialImageUrl={initialImageUrl}
                pendingImagePreviewUrl={pendingImagePreviewUrl}
                onPendingImageSelect={onPendingImageSelect}
                onPendingImageClear={onPendingImageClear}
                basePrice={basePrice}
                stepConfig={stepConfig}
                formData={formData || {}}
                onChange={onChange}
                errors={errors}
                setErrors={setErrors}
                hssTemplates={hssTemplates}
                paymentTemplates={paymentTemplates}
                onToggleTemplate={onToggleTemplate}
                onNewTemplate={onNewTemplate}
                onEditTemplate={onEditTemplate}
                duration={duration}
                itineraryDays={itineraryDays}
                onDayChange={onDayChange}
                onAddLineItem={onAddLineItem}
                onLineItemChange={onLineItemChange}
                onRemoveLineItem={onRemoveLineItem}
                tripComponents={tripComponents}
                itineraryDaysList={itineraryDaysList}
                cityOptions={cityOptions}
                isCitiesLoading={isCitiesLoading}
                tripCountry={tripCountry}
                takenCountries={takenCountries}
                onNewComponent={onNewComponent}
                onNewHssTemplate={onNewHssTemplate}
                onSearchExistingComponent={onSearchExistingComponent}
                tripCurrency={tripCurrency}
                lookupOptions={lookupOptions}
                itemDefaults={itemDefaults}
                tripsList={tripsList}
                isTripsLoading={isTripsLoading}
                packageId={packageId}
                packageInitialImageUrl={packageInitialImageUrl}
                pendingPackageImagePreviewUrl={pendingPackageImagePreviewUrl}
                onPendingPackageImageSelect={onPendingPackageImageSelect}
                onPendingPackageImageClear={onPendingPackageImageClear}
            />
        </>
    );
}

export default WizardStepPage;
